import RequestManager from '../requests/RequestManager';
import PinStatusWithTimerValidationTask from "src/requests/tasks/user/PinStatusWithTimerValidationTask";

class PinParental {
    constructor() {
        this.hasPINParental = this.hasPINParental.bind(this);
        this.channelsRequest = new PinStatusWithTimerValidationTask();
    }

  hasPINParental() {
        return new Promise((resolve, reject) => {
            RequestManager.addRequest(this.channelsRequest).then((resp) => {
                if(!resp.response.errors){
                    const PINParentalActive = resp.response.pin_purchase.status === 1 || resp.response.pin_parental.status === 1 || resp.response.pin_channel.status === 1;
                    resolve(PINParentalActive);
                }
            }).catch((err) => {
                console.error(err);
                reject(err);
            });
        });

    }
}

export default PinParental;



// WEBPACK FOOTER //
// ./src/utils/PinParental.js